import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

export default function DeleteObjectiveMenu({
  anchorEl,
  handleClose,
  deleteTab,
}: {
  anchorEl: HTMLElement | null;
  handleClose: () => void;
  deleteTab: () => void;
}) {
  const open = Boolean(anchorEl);

  return (
    <div>
      <Menu
        id="demo-positioned-menu"
        aria-labelledby="demo-positioned-button"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <MenuItem onClick={deleteTab}>Kompetenz löschen</MenuItem>
      </Menu>
    </div>
  );
}
